export default __webpack_public_path__ + "static/media/thread.9f8a2e59.png";